import { Col, Row } from '@advanza/grid'
import { Button, Divider } from '@advanza/ui'
import A from 'components/ui/A'
import { useCurrentCountry } from 'hooks/miscHooks'
import React, { useState } from 'react'

const ExactExportBlock = ({
    items,
    type,
    isExporting,
    exportFunc,
    loadBatchesFunc,
    downloadUrl,
    description,
}) => {
    const [lastAction, setLastAction] = useState(null)
    const blockIsExporting = isExporting === type
    const { protocol, hostname } = window.location
    const country = useCurrentCountry()
    const downloadHref = (batchNr) =>
        `${protocol}//${hostname}/api/office/invoices/${downloadUrl}/${batchNr}?country=${country}`
    const hasExportResult = items && typeof items.count === 'number'
    return (
        <div>
            {description && (
                <>
                    <p>{description}</p>
                    <Divider m />
                </>
            )}
            {hasExportResult &&
                (items.count === 0 ? (
                    <>
                        <p>
                            <i>Nothing to export right now.</i>
                        </p>
                        <Divider m />
                    </>
                ) : (
                    <>
                        <b>
                            Batch #{items.batchNr}: {items.count} {type}
                            {items.updatedCount > 0 && ` (${items.updatedCount} updated)`}
                        </b>
                        <p>
                            <A external href={downloadHref(items.batchNr)} target="_blank">
                                Download csv
                            </A>
                        </p>
                        <Divider m />
                    </>
                ))}
            {items && items.prevBatches && (
                <>
                    <b>Previous batches</b>
                    {items.prevBatches.map(([batch, nr]) => (
                        <p key={batch}>
                            <A external href={downloadHref(batch)} target="_blank">
                                Download csv batch #{batch} {type} ({nr})
                            </A>
                        </p>
                    ))}
                    <Divider m />
                </>
            )}
            <Row between="xs" middle="xs">
                <Col x>
                    <Button
                        appearance="primary"
                        disabled={isExporting}
                        onClick={() => {
                            setLastAction('export')
                            exportFunc()
                        }}>
                        {blockIsExporting && lastAction === 'export'
                            ? 'Exporting…'
                            : `Export new ${type}`}
                    </Button>
                </Col>
                <Col x>
                    <Button
                        appearance="text_primary"
                        disabled={isExporting}
                        onClick={() => {
                            setLastAction('load')
                            loadBatchesFunc()
                        }}>
                        {blockIsExporting && lastAction === 'load'
                            ? 'Loading…'
                            : 'Show previous batches'}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}

export default ExactExportBlock
